module.exports = __webpack_public_path__ + "img/Email.fc53d24d.svg";